import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { MANAGER_PAGES } from '../utils/permissions';

interface NavigationProps {
  currentPage: string;
  onPageChange: (page: string) => void;
}

export const Navigation: React.FC<NavigationProps> = ({ onPageChange }) => {
  const location = useLocation();
  const { user, logout, can } = useAuth();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Close mobile menu when route changes
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  const navItems = [
    ...MANAGER_PAGES.filter((page) => page.inNavigation && can(...page.permissions)),
    { path: '/register', label: 'Đăng ký ca' },
  ];

  const handleLogout = () => {
    setIsMobileMenuOpen(false);
    logout();
  };

  return (
    <nav className="navigation">
      <div className="nav-container">
        {/* Brand Logo */}
        <Link to="/" className="nav-brand" onClick={() => onPageChange('schedule')}>
          <span>HomeTools Duni</span>
        </Link>

        {/* Desktop Menu */}
        <ul className="nav-menu nav-menu-desktop">
          {navItems.map((item) => (
            <li key={item.path} className="nav-item">
              <Link
                to={item.path}
                className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
                onClick={() => onPageChange(item.path.replace('/', ''))}
              >
                {item.label}
              </Link>
            </li>
          ))}
        </ul>

        {/* Desktop User Info */}
        <div className="nav-user nav-user-desktop">
          <div className="user-info">
            <i className="fas fa-user"></i>
            <span>{user?.name || user?.username}</span>
          </div>
          <button className="logout-btn" onClick={handleLogout}>
            <i className="fas fa-sign-out-alt"></i>
            <span>Đăng xuất</span>
          </button>
        </div>

        {/* Mobile Hamburger Button */}
        <button
          className="mobile-nav-toggle"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle navigation menu"
        >
          <i className={`fas ${isMobileMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
        </button>

        {/* Mobile Slide-down Drawer */}
        <div className={`mobile-nav-drawer ${isMobileMenuOpen ? 'is-open' : ''}`}>
          <ul className="mobile-nav-menu">
            {navItems.map((item) => (
              <li key={item.path} className="nav-item">
                <Link
                  to={item.path}
                  className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
                  onClick={() => {
                    onPageChange(item.path.replace('/', ''));
                    setIsMobileMenuOpen(false);
                  }}
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>

          <div className="mobile-user-section">
            <div className="user-info">
              <i className="fas fa-user"></i>
              <span>{user?.name || user?.username}</span>
            </div>
            <button className="logout-btn" onClick={handleLogout}>
              <i className="fas fa-sign-out-alt"></i>
              <span>Đăng xuất</span>
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};



